import { render } from "./eSesjaTab.vue?vue&type=template&id=dc8f9b7e"
import script from "./eSesjaTab.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./eSesjaTab.vue?vue&type=script&charset=utf-8&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__